jQuery(function ($) {

    let parent_scope  = '.post-type-archive-video',
        $filter_list  = $('.js-filter-list'),
        $filter       = $('.js-filter'),
        $clear_filter = $('.js-filter-clear'),
        $search       = $('.js-search-box'),
        $icon         = $('.js-search-icon'),
        $wrapper      = $('.js-list-wrapper');

    $filter.on('click', function(e) {
        getResults();
    });

    $(parent_scope).on('click', '.js-pagination .page-link', function(e) {
       e.preventDefault();
       let page = $(e.currentTarget).attr('data-page');
       getResults(page);
       $(window).scrollTop($("#layout-content").offset().top);
    });


    $clear_filter.on('click', function(e) {
        $filter_list.find('input:checkbox').each(function(){
            $(this).prop('checked', false);
        });
        $('.search-box').val('');
        getResults();
    });

    $search
        .on('keydown', function (e) {
            if (e.which === 9) { //tab
                getResults();
            }
        })
        .on('keypress', function (e) {
            if (e.which === 13) {  // enter
                getResults();
            }
        });

    $icon.on('click', function (e) {
        getResults();
    });

    function getResults(page) {
        let pageNum = isNaN(page) ? 1 : page;

        $.ajax({
            type: 'GET',
            cache: true,
            url: waystar_params.endpoint,
            data: {
                _ajax_nonce: waystar_params.security,
                action: 'filter_videos',
                business_challenge: $('.js-business_challenge:checked').map(function(){ return $(this).val() }).get(),
                client_segment: $('.js-client_segment:checked').map(function(){ return $(this).val() }).get(),
                term: $search.val(),
                paged: pageNum
            },
            success: function (response) {
                $wrapper.html(response.result);
                lazy_load();
            },
            error: function (jqXHR, textStatus, errorThrown, response) {
                $wrapper.html(textStatus);
            }
        });
    }
});